const BeforeAfterSection = () => {
  return (
    <section className="section-padding">
      <div className="container-narrow">
        <div className="text-center mb-12">
          <h2 data-reveal className="text-3xl md:text-4xl font-semibold mb-4 text-foreground">
            What a clear, professional website looks like
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div data-reveal-pop style={{ transitionDelay: "100ms" }} className="space-y-3">
            <span className="text-sm text-muted-foreground">Before</span>
            <div className="aspect-video rounded-lg border border-border/30 overflow-hidden bg-muted/20 flex items-center justify-center">
              <img
                src="/images/before-cluttered-example.png"
                alt="Example of a cluttered real estate agent profile page"
                className="max-w-full max-h-full object-contain"
                width={1120}
                height={630}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div data-reveal-pop style={{ transitionDelay: "250ms" }} className="space-y-3">
            <span className="text-sm text-muted-foreground">After</span>
            <div className="aspect-video rounded-lg border border-border/30 overflow-hidden">
              <video
                className="w-full h-full object-cover object-top"
                autoPlay
                muted
                loop
                playsInline
                disablePictureInPicture
                src="/videos/site-elevation-sample.mov"
              />
            </div>
          </div>
        </div>

        <p data-reveal style={{ transitionDelay: "350ms" }} className="text-center text-muted-foreground mt-8">
          Same agent. Clearer positioning. Stronger first impression.
        </p>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
